import SettingsIcon from "../../assets/img/icons/settings.svg";
import { StyledAdvancedSearch, StyledAdvancedSearchButton } from "../../styles/StyledSearch";

export default function AdvancedSearch() {
	const handleAdvancedSearchButton = (e) => {
		e.preventDefault();
	};
	return (
		<StyledAdvancedSearch data-testid="advanced-search">
			<StyledAdvancedSearchButton onClick={handleAdvancedSearchButton}>
				<img src={SettingsIcon} alt="Settings" />
				Advanced search
			</StyledAdvancedSearchButton>
		</StyledAdvancedSearch>
	);
}
